import masterActions from "./actions";

const initialState = {
  projectList: {
    all: [],
    filtered: [],
    grievance: [],
  },
  courseList:{
    all:[],
    filtered:[]

  },
  courseListAdmin:[],
  batchList:{
    all:[],
    filtered:[]
  },
   templateList:{
    all:[],
    filtered:[]
  },
  templateName:{
    all:[],
    filtered:[]
},
metaData:[],
  otbsCourseList:{all:[],filtered:[]},
  activeCourses: [],
  objectionList: [],
};

const masterReducer = (state = initialState, action) => {
  switch (action.type) {
    case masterActions.SET_PROJECT_LIST:
      return {
        ...state,
        projectList: action.payload,
      };
    case masterActions.SET_GRIEVANCE:
      return {
        ...state,
        grievance: action.payload,
      };
      case masterActions.SET_COURSE_LIST:
      return {
        ...state,
        courseList: action.payload,
      };
      case masterActions.SET_COURSE_LIST_BY_ADMIN:
      return {
        ...state,
        courseListAdmin: action.payload,
      };
      case masterActions.SET_ALL_BATCH:
        return {
          ...state,
          batchList: action.payload,
        };
        case masterActions.SET_OTBS_COURSE_LIST:
          return {
            ...state,
            otbsCourseList:action.payload
          }
        case masterActions.SET_COURSE_CANDIDATE_LIST:
          return {
            ...state,
            coursecandidatelist:action.payload
          }
        case masterActions.SET_ADMITCARD_DOWNLOAD_LIST:
          return {
            ...state,
            getAdmitCardDownloadList:action.payload
          }
        case masterActions.SET_SCORECARD_DOWNLOAD_LIST:
          return {
            ...state,
            getScoreCardDownloadList:action.payload
          }
          case masterActions.SET_TEMPLATE_LIST:
          return {
            ...state,
          templateList:action.payload
          }
          case masterActions.SET_MASTER_TEMPLATE_NAME:
            return {
              ...state,
              templateName:action.payload
            }
            case masterActions.SET_META_DATA:
              return {
                ...state,
                metaData:action.payload
              }
    case masterActions.SET_ACTIVE_COURSES:
      return {
        ...state,
        activeCourses: action.payload,
      };
    case masterActions.SET_OJECTION_LIST:
      return {
        ...state,
        objectionList: action.payload,
      };
    default:
      return state;
  }
};

export default masterReducer;
